export default {
  contact: {
    hero: {
      eyebrow: 'Contact',
      title: 'Get in touch',
      lead: 'Whether initial information, concrete planning or an on-site visit – we look forward to your message.',
    },
    info: {
      partner: 'Your partner for security technology',
      owner: 'Owner',
      address: 'Address',
      phone: 'Phone',
      email: 'Email',
      hours: 'Business hours',
      area: 'Service area',
      viewAreas: 'View all service areas',
    },
    form: {
      title: 'Project enquiry',
      lead: 'Fill in the form. We will get back to you promptly.',
      customerType: 'Private or commercial *',
      select: 'Please select',
      privat: 'Private',
      gewerbe: 'Commercial',
      name: 'Name *',
      company: 'Company',
      phone: 'Phone',
      email: 'Email *',
      projectLocation: 'Project location',
      objectType: 'Property type',
      objEfh: 'Family home',
      objMfh: 'Apartment building',
      objLaden: 'Retail / shop',
      objBuero: 'Office / practice',
      objGastronomie: 'Hospitality',
      objLager: 'Warehouse / logistics',
      objWerkstatt: 'Workshop / trade',
      objSonstige: 'Other',
      service: 'Desired service',
      svcBeratung: 'Initial consultation',
      svcPlanung: 'Planning & quote',
      svcInstallation: 'Installation & setup',
      svcErweiterung: 'Extension of existing system',
      svcWartung: 'Maintenance / support',
      svcCare: 'SSG Care enquiry',
      systemStatus: 'System status',
      stNeu: 'New system',
      stBestehend: 'Extend existing system',
      stAustausch: 'Full replacement',
      stUnsicher: 'Not sure yet',
      message: 'Message',
      messagePlaceholder: 'Briefly describe your project or questions...',
      maxChars: 'Maximum 500 characters',
      fileUpload: 'File upload',
      fileHint: 'Photos, floor plans or other documents (optional)',
      fileNote: 'Note: file uploads are treated as "Uncollectable".',
      callback: 'Preferred callback time',
      callbackNone: 'No callback desired',
      vormittag: 'Morning',
      nachmittag: 'Afternoon',
      abend: 'Evening',
      consent: 'I have read the privacy policy and agree to the processing of my data to handle this request. *',
      success: 'Thank you for your request. We will get back to you promptly.',
      submit: 'Send enquiry',
      submitting: 'Sending...',
    },
  },
};